"use strict";
const negateExpression = require('./negateExpression');
const { EQUALS, NOT_EQUALS } = require('../definitions/operators');
module.exports = negateExpression(EQUALS, NOT_EQUALS);
//# sourceMappingURL=notEqualsExpression.js.map